import { library, } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fasr } from "@fortawesome/sharp-regular-svg-icons";
import { fass } from "@fortawesome/sharp-solid-svg-icons";
import cn from "clsx";
import decamelize from "decamelize";
import * as React from "react";
library.add(fasr, fass);
const convertFormat = (name) => {
    if (name.startsWith("fa") && /[A-Z]/.test(name) && !name.includes("-")) {
        const plainName = name.substring(2, name.length);
        return decamelize(plainName, { separator: "-" });
    }
    return name;
};
const FaIcon = React.forwardRef(({ className, size, prefix, iconName, children, style, ...props }, ref) => {
    const name = convertFormat(iconName);
    const icon = { prefix: prefix, iconName: name };
    return (React.createElement(FontAwesomeIcon, { icon: icon, className: cn(`in-icon-fa--${size}`, className) }));
});
FaIcon.displayName = "Icon";
export { FaIcon };
//# sourceMappingURL=faIcon.js.map